module.exports = __webpack_public_path__ + "static/media/3.dc001492.jpg";